import http from "../http-common";

class MajorService {
  createMajor(data) {
    return http.post(`/api/major`, data);
  }
  getMajors() {
    return http.get(`/api/major`);
  }
  getMajorByFilter(data){
    return http.get(`/api/major/getMajorByFilter?code=`+data.code+'&&nameTH='+data.nameTH+'&&section='+data.section+'&&group_m='+data.group_m+'&&number='+data.number+'&&credit='+data.credit);
  }
  updateMajor(id, data) {
    return http.put(`/api/major/${id}`, data);
  }
}

export default new MajorService();